import {merge} from 'lodash-es';
import base from '@/i18n/ko';
import menu from './menu';
import label from './label';

export default merge(base, {
    menu,
    label,
});
